// const state = {}

// ==================================================
// INITIALIZERS
// ==================================================

// function setDefaultState() {
//   // set default state
// }

function setListeners() {
    document.addEventListener('DOMContentLoaded', removeHiddenDisplayStyling);
}

function removeHiddenDisplayStyling() {
    setTimeout(() => {
        document.body.className = document.body.className.replace(' js', '');
    }, 205);
}

// ==================================================
// HANDLERS
// ==================================================

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    // setDefaultState()
    setListeners();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/global.js